export default "__VITE_ASSET__ZMwU6ZFM__"